import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || '#51A2B5'}
      fillRule="evenodd"
      d="M1.631 0a.455.455 0 0 0-.422.328L.055 3.834A1.1 1.1 0 0 0 0 4.176v1.395C0 6.36.576 7 1.286 7c.71 0 1.285-.64 1.285-1.428C2.571 6.36 3.147 7 3.857 7c.71 0 1.286-.64 1.286-1.428C5.143 6.36 5.718 7 6.428 7s1.285-.639 1.287-1.428C7.715 6.361 8.29 7 9 7s1.286-.64 1.286-1.428c0 .788.575 1.428 1.286 1.428.71 0 1.285-.639 1.285-1.428 0 .789.576 1.428 1.286 1.428.71 0 1.285-.64 1.285-1.428 0 .788.576 1.428 1.287 1.428C17.425 7 18 6.36 18 5.572V4.177c0-.117-.019-.233-.055-.343L16.791.328A.455.455 0 0 0 16.369 0H1.63Z"
      clipRule="evenodd"
    />
    <path
      fill={props.color || '#51A2B5'}
      fillRule="evenodd"
      d="M2 7.615V11.5H.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25h16.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25H16V7.615a1.95 1.95 0 0 1-.572-.352 2 2 0 0 1-.428.288V11.5H3V7.551a2 2 0 0 1-.429-.288c-.167.148-.36.268-.571.352Zm13-.979c.042-.042.082-.087.12-.136H15v.136Zm.737-.136a1.4 1.4 0 0 0 .263.26V6.5h-.263ZM2 6.76a1.3 1.3 0 0 0 .263-.26H2v.26Zm.88-.26H3v.136a1.5 1.5 0 0 1-.12-.136Zm-1.63 7a.25.25 0 0 0-.25.25v3.75a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-3.75a.25.25 0 0 0-.25-.25H1.25Z"
      clipRule="evenodd"
    />
    <path
      fill={props.color || '#51A2B5'}
      d="M4 10.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1Z"
    />
    <path
      fill={props.color || '#51A2B5'}
      d="M5 10.75a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5Zm4 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    />
  </svg>
)
export default SvgComponent
